import React, { useMemo } from 'react';
import { Tooltip } from '@components/common/Tooltip';
import { calculateValuePercentageChange } from '../../../../utils/calculateValuePercentageChange';
import { AnalyticsChangeIndicator } from '../../../AnalyticsChangeIndicator/AnalyticsChangeIndicator';
import * as S from './AnalyticsTableCell.styled';
import { isBreakdownValue, isValuePair } from './AnalyticsTableCell.types';
import { TableCellBreakdown } from './components/TableCellBreakdown';
const formatValue = (value) => {
    return typeof value === 'string' ? value : value.toLocaleString();
};
export const AnalyticsTableCell = ({ value, columnIndex, align = 'left', isSummary = false, }) => {
    const mainValue = useMemo(() => {
        const val = isValuePair(value) ? value[0] : value;
        return isBreakdownValue(val) ? val.value : val;
    }, [value]);
    const subValue = useMemo(() => {
        if (!isValuePair(value))
            return undefined;
        const val = value[1];
        return isBreakdownValue(val) ? val.value : val;
    }, [value]);
    const renderMainValue = () => {
        const val = isValuePair(value) ? value[0] : value;
        const hasBreakdown = isBreakdownValue(val);
        const displayedValue = (React.createElement(S.MainValue, { bold: isSummary, underline: hasBreakdown }, formatValue(mainValue)));
        if (hasBreakdown) {
            return (React.createElement(Tooltip, { size: "small", content: React.createElement(TableCellBreakdown, { title: val.breakdown.title, items: val.breakdown.items }), placement: "bottom", strategy: "fixed" }, displayedValue));
        }
        return displayedValue;
    };
    const renderCompareValue = () => {
        if (!isValuePair(value))
            return null;
        const compareValue = value[1];
        const hasBreakdown = isBreakdownValue(value[1]);
        const displayedValue = (React.createElement(S.CompareValue, { underline: hasBreakdown }, formatValue(subValue)));
        if (hasBreakdown) {
            return (React.createElement(Tooltip, { size: "small", content: React.createElement(TableCellBreakdown, { title: compareValue.breakdown.title, items: compareValue.breakdown.items }), placement: "bottom", strategy: "fixed" }, displayedValue));
        }
        return displayedValue;
    };
    const renderSummaryChanges = () => {
        if (columnIndex === 0) {
            return React.createElement(S.ChangeIndicator, { align: align }, "% Change");
        }
        const isComparable = typeof mainValue === 'number' && typeof subValue === 'number';
        if (!isComparable)
            return (React.createElement(S.ChangeIndicator, { align: align },
                React.createElement(AnalyticsChangeIndicator, { size: "small", value: 0, showValue: false })));
        const changeValue = calculateValuePercentageChange([mainValue, subValue]);
        return (React.createElement(S.ChangeIndicator, { align: align },
            React.createElement(AnalyticsChangeIndicator, { size: "small", value: changeValue, showZero: false })));
    };
    return (React.createElement(S.Container, null,
        renderMainValue(),
        renderCompareValue(),
        isSummary && renderSummaryChanges()));
};
